import { createFileRoute } from "@tanstack/react-router";

import ProxyList from "./-components/ProxyList";

export const Route = createFileRoute(
  "/_app/_dashboard/subscription/proxyreplacement"
)({
  component: ProxyList,
});
